import { render, staticRenderFns } from "./QryBlackDialog.vue?vue&type=template&id=1fa921e2&scoped=true&"
import script from "./QryBlackDialog.vue?vue&type=script&lang=js&"
export * from "./QryBlackDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa921e2",
  null
  
)

export default component.exports